import { defineAsyncComponent } from 'vue'

const StagingArea = defineAsyncComponent(() => import('./staging-area.vue'))
const StagingAreaDetails = defineAsyncComponent(() => import('./staging-area-details.vue'))
const StagingAreaModal = defineAsyncComponent(() => import('./staging-area-modal.vue'))
const StagingAreasTable = defineAsyncComponent(() => import('./staging-areas-table.vue'))
const StagingAreasSelect = defineAsyncComponent(() => import('./staging-areas-select.vue'))

export { StagingArea, StagingAreaDetails, StagingAreaModal, StagingAreasSelect, StagingAreasTable }
